<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { formatDate } from '@/common/utils/formatDate'
import MissionStatusIndicator from 'Modules/components/feedback/MissionStatusIndicator.vue'
import { JeteyeRoutes } from 'Modules/RouterSetup'

const props = defineProps({
  data: { type: Object, default: null },
})
const router = useRouter()
const sort = ref({
  tailNumber: null,
  status: null,
  lastActivity: null,
  openInspections: null,
  comments: null,
})
const rowClick = (row) => {
  const aircraftUUID = row.aircraftUuid
  router.push({ name: JeteyeRoutes.Aircraft, params: { aircraftUUID: aircraftUUID } })
}
const getParsedData = () => {
  const sorted = !Object.values(sort.value).every((v) => v === null)
  const rowData = []
  for (const [key, value] of Object.entries(props.data)) {
    if (!sorted)
      rowData.push({
        rowType: 'subheader',
        label: key,
      })
    // Sort by update date to show latest activity record on the table
    value.sort((a, b) => new Date(b.updateDate) - new Date(a.updateDate))
    value.forEach((p) => {
      rowData.push({
        rowType: 'data',
        ...p,
        updateDate: formatDate(p.updateDate),
      })
    })
  }
  return rowData
}
const getCellStyle = ({ row }) => {
  if (row.rowType === 'subheader') {
    return {
      padding: '0 0',
    }
  }
  return
}
const getColSpan = ({ row }) => {
  if (row.rowType === 'subheader') {
    return {
      colspan: 6,
      rowspan: 1,
    }
  } else
    return {
      colspan: 1,
      rowspan: 1,
    }
}
const columnEvent = (column) => {
  const { property, order } = column
  sort.value[property] = order
}
</script>

<template>
  <el-table
    :data="getParsedData()"
    :stripe="true"
    :cell-style="getCellStyle"
    :span-method="getColSpan"
    height="99%"
    @header-click="columnEvent"
    @row-click="rowClick"
  >
    <el-table-column prop="tailNumber" label="Tail Number" sortable>
      <template #default="scope">
        <div v-if="scope.row.rowType === 'subheader'" class="bg-stone-700 text-white mx-[-12px] py-1 px-3">
          <span> <font-awesome-icon class="mr-2" icon="fa-solid fa-plane-up" />{{ scope.row.label }}</span>
        </div>
        <div v-else>
          {{ scope.row.tailNumber }}
        </div>
      </template>
    </el-table-column>
    <el-table-column prop="status" label="Status" sortable>
      <template #default="scope">
        <MissionStatusIndicator v-if="scope.row.rowType !== 'subheader'" :status="scope.row.status" />
      </template>
    </el-table-column>
    <el-table-column prop="updateDate" label="Last Activity" sortable />
    <el-table-column prop="openInspections" label="Open Inspections" sortable />
    <!--el-table-column prop="comments" label="Comments" sortable /-->
    <template #empty>
      <div class="h-full w-full flex items-center justify-center">No Data</div>
    </template>
  </el-table>
</template>

<style></style>
